module.exports = __webpack_public_path__ + "static/img/08101921bixd.99f6ed1f.jpg";